/**
 * Opens a recipe modal from an anchor.
 *
 * `ModalOpener` in global.js binds to a `<button>` child only, so it silently
 * ignores the real `<a href>` that is this grid's no-JS fallback. This element
 * delegates from the grid instead and hands the anchor itself to
 * `ModalDialog.show()`, which already owns Escape, backdrop click, body scroll
 * lock and focus restoration. Every failure path here falls through to the
 * anchor's own navigation, so a broken modal degrades to a working link.
 */
if (!customElements.get('recipe-modal-opener')) {
  customElements.define(
    'recipe-modal-opener',
    class RecipeModalOpener extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      handleClick(event) {
        const link = event.target.closest('[data-recipe-modal]');
        if (!link) return;
        // Let the browser handle new-tab, new-window and middle clicks.
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

        // ModalDialog re-parents itself to <body>, so the target is never a descendant of this element.
        const modal = document.getElementById(link.getAttribute('data-recipe-modal'));
        if (!modal || typeof modal.show !== 'function') return;

        event.preventDefault();
        modal.show(link);
      }
    }
  );
}
